import React from 'react';
import { Typography } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { buildImgCloudRoutePath } from '../../utils/appRouting';
import './index.css';

const { Title, Paragraph } = Typography;

interface ToolPageHeaderProps {
  backTo: string;
  backText: React.ReactNode;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  icon?: React.ReactNode;
  extra?: React.ReactNode;
  className?: string;
}

const ToolPageHeader: React.FC<ToolPageHeaderProps> = ({
  backTo,
  backText,
  title,
  subtitle,
  icon,
  extra,
  className,
}) => {
  const navigate = useNavigate();
  const rootClassName = ['tool-page-header', className].filter(Boolean).join(' ');

  const handleBackClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.altKey ||
      event.ctrlKey ||
      event.shiftKey
    ) {
      return;
    }

    event.preventDefault();
    navigate(backTo);
  };

  return (
    <div className={rootClassName}>
      <a
        href={buildImgCloudRoutePath(backTo)}
        onClick={handleBackClick}
        className="tool-page-header__back"
      >
        <ArrowLeftOutlined />
        {backText}
      </a>
      <div className="tool-page-header__title-row">
        <Title level={5} className="tool-page-header__title">
          {icon}
          {title}
        </Title>
        {extra}
        {subtitle ? (
          <Paragraph type="secondary" className="tool-page-header__subtitle">
            {subtitle}
          </Paragraph>
        ) : null}
      </div>
    </div>
  );
};

export default ToolPageHeader;
